import { Controller } from "@hotwired/stimulus";
import { ProductCard, WishlistIcon } from "../components";
import { checkAppmate } from "../helpers";

export default class extends Controller {
  static targets = ["icon", "products"];

  async handleCallback(collection, product, action = null, variant = null) {
    const products = collection?.items[0].products || null;

    const targetId = product.selected_variant_id;
    if (action === "remove") {
      this.productsTarget.querySelector(`[id="${targetId}"]`).remove();
    } else if (action === "add") {
      try {
        const res = await fetch(
          `/products/${products[collection.items.length - 1].handle}?view=json`
        );
        const data = await res.json();
        this.productsTarget.innerHTML += ProductCard(
          data,
          variant ? variant : product.selected_variant_id
        );
      } catch (err) {
        console.error(
          "There was an error adding an item to the wishlist...",
          err
        );
      }
    } else if (products) {
      products.map(async (product) => {
        // Fetch this URL to get additional metadata
        try {
          const res = await fetch(`/products/${product.handle}?view=json`);
          if (res.ok) {
            const data = await res.json();
            return (this.productsTarget.innerHTML += ProductCard(
              data,
              variant ? variant : product.selected_variant_id,
              true
            ));
          }
        } catch (err) {
          console.error("There was an error fetching product data...", err);
        }
      });
    }
  }
  async productsTargetConnected() {
    const handleCallback = (collection) => {
      const products = collection?.items[0].products || null;

      if (products) {
        products.map(async (product) => {
          try {
            // Fetch this URL to get additional metadata
            const res = await fetch(`/products/${product.handle}?view=json`);

            if (res.ok) {
              const data = await res.json();

              return (this.productsTarget.innerHTML += ProductCard(
                data,
                product.selected_variant_id
              ));
            }
          } catch (err) {
            console.error(
              "There was an error fetchingproducts on connection...",
              err
            );
          }
        });
      }
    };

    checkAppmate(handleCallback);
  }

  toggle(e) {
    const { state, product, variant } = e.params;
    const targetElem = e.currentTarget;
    if (state === "add") {
      // Add to wishlist
      Appmate.wk.addProduct(product, variant).then(() => {
        targetElem.parentElement.innerHTML = WishlistIcon(
          variant,
          product?.id || product,
          "add"
        );

        if (window.location.pathname === "/pages/wishlist") {
          this.handleCallback(Appmate.wk.collection, product, "add", variant);
        }
      });
    } else if (state === "remove") {
      Appmate.wk.removeProduct(product, variant).then((product, test) => {
        targetElem.parentElement.innerHTML = WishlistIcon(
          variant,
          product?.id || product,
          "remove"
        );

        if (window.location.pathname === "/pages/wishlist") {
          this.handleCallback(Appmate.wk.collection, product, "remove");
        }
      });
    }
  }
}
